import React from "react";

import DocumentTitle from "./DocumentTitle";
import Logo from "./Logo";
import BuilderField from "./onboarding/BuilderField";

const LayoutAuth = ({ children, title, subtitle, maxWidthClass = "sm:max-w-md", compact = false, alignTop = false }) => (
  <>
    <DocumentTitle title={title} />
    <div
    className={`relative h-full min-h-screen overflow-y-auto bg-theme-secondary flex flex-col ${
      alignTop ? "justify-start" : "justify-start sm:justify-center"
    } ${compact ? "py-6" : "py-12"} sm:px-6 lg:px-8`}
  >
    <BuilderField className="pointer-events-none fixed inset-0 h-full w-full opacity-30" />
    <div className={`relative sm:mx-auto sm:w-full ${maxWidthClass} mx-4 sm:mx-auto`}>
      <div className={`bg-theme-main shadow-xl rounded-2xl border border-theme-secondary ${
        compact ? "py-6 px-5 sm:px-7" : "py-12 px-8 sm:px-12"
      }`}>
        <div className="flex flex-col items-center text-center">
          <Logo className={compact ? "h-7 w-[72px]" : "h-8 w-[83px]"} />
          <h2 className={`${compact ? "mt-3 text-lg" : "mt-[18px] text-[22px]"} font-bold text-theme-text`}>
            { title }
          </h2>
          {subtitle ? (
            <p className={`${compact ? "mt-1 text-xs" : "mt-2 text-[13px]"} text-theme-text opacity-60 max-w-xs`}>
              { subtitle }
            </p>
          ) : ''}
        </div>

        <div className={compact ? "mt-4" : "mt-9"}>
          { children }
        </div>
      </div>
    </div>
  </div>
  </>
);

export default LayoutAuth;
